import Backbone from 'backbone'
import permissions from 'scoreboard/components/permissions'

var ReportFolder = Backbone.Model.extend({

	section: 'reports',

	domainType: 'report',

	urlRoot: 'api/reports',

	defaults: {
		type: 'folder'
	},

	isEditable: function() {
		return permissions.reports(this.get('organizationId')) && permissions.isEditableIfReplicated(this)
	},

	parse (res, opts) {
		return res.metadata || res
	}

})

export default ReportFolder

ReportFolder.__filename__ = 'reports/report-folder.js'
